// Libs
import { useMemo } from 'react';

// Contexts
import { useAuth } from '@/common/contexts/AuthContext';

const useTotal = ({ isUpdated, pricesAndStocks, products, total }) => {
  const { isShowNetPrice, zergRush } = useAuth();

  const hasData = useMemo(() => !isUpdated && !zergRush, [isUpdated, zergRush]);

  /**
   * Calculate total with selected products.
   * Price is coming from product or for pricesAndStocks Map param
   * total is customer total price if isShowNetPrice is true
   * else, total is public total price.
   * If a price is missing, total display the total of selected product with a price
   * @type {function(): null}
   */
  const getTotal = useMemo(() => {
    let totalTemp = null;

    if (total) {
      return total;
    }

    if (products !== undefined) {
      const selectedProducts = products.filter((item) => item.is_selected);

      selectedProducts.forEach((product) => {
        const { quantity } = product;
        const productPrices =
          product?.price_and_stock ||
          product.product?.price_and_stock ||
          (pricesAndStocks &&
            pricesAndStocks.size > 0 &&
            pricesAndStocks.get(product.sku));
        if (productPrices?.price) {
          if (isShowNetPrice) {
            totalTemp += productPrices.price.customer_price
              ? Math.trunc(productPrices.price.sale.customer_price * quantity)
              : 0;
          } else {
            totalTemp += productPrices.price.public_price
              ? Math.trunc(
                  (productPrices.price.sale.discount_price ||
                    productPrices.price.sale.public_price) * quantity,
                )
              : 0;
          }
        }
      });

      // To prevent display total = 0 if no price exists
      if (totalTemp === 0) {
        totalTemp = null;
      }
    }

    return totalTemp;
  }, [isShowNetPrice, pricesAndStocks, products, total]);

  return {
    hasData,
    total: getTotal,
  };
};

export default useTotal;
